import { useCallback, useMemo, useState } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';

export interface IConfirmUnsavedChangesModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function useConfirmUnsavedChangesModal({
  isOpen,
  onConfirm,
  onCancel,
}: IConfirmUnsavedChangesModalProps) {
  // HANDLERS
  const handleCloseModal = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleCancelModal = useCallback(
    (e?: React.MouseEvent<HTMLButtonElement>) => {
      if (e) {
        handleDomBubbleEvent(e);
      }
      onCancel();
    },
    [onCancel]
  );

  const handleConfirm = useCallback(
    (e?: React.MouseEvent<HTMLButtonElement>) => {
      if (e) {
        handleDomBubbleEvent(e);
      }
      onConfirm();
    },
    [onConfirm]
  );

  return {
    // Modal
    isOpen,

    // Handlers
    handleCloseModal,
    handleCancelModal,
    handleConfirm,
  };
}
